<glxy-page [pagePadding]="false" [isLoading]="isBusy">
  <glxy-page-toolbar>
    <glxy-page-nav>
      @if (previousPageUrl) {
        <glxy-page-nav-button
          [previousPageTitle]="(previousPageTitle ?? 'KNOWLEDGE_SHARING.DETAIL.BACK') | translate"
          [previousPageUrl]="previousPageUrl"
        ></glxy-page-nav-button>
      } @else {
        <button
          mat-icon-button
          class="detail__back"
          (click)="back.emit()"
          [matTooltip]="'KNOWLEDGE_SHARING.DETAIL.BACK' | translate"
          [attr.aria-label]="'KNOWLEDGE_SHARING.DETAIL.BACK' | translate"
        >
          <mat-icon>arrow_back</mat-icon>
        </button>
      }
    </glxy-page-nav>
    <glxy-page-title>{{ detail.kb.name }}</glxy-page-title>
    @if (showSharing()) {
      <glxy-page-actions>
        <button mat-flat-button color="primary" class="detail__share" (click)="share.emit(detail)">
          <mat-icon>group_add</mat-icon>
          {{ 'KNOWLEDGE_SHARING.BASE_TABLE.SHARE' | translate }}
        </button>
      </glxy-page-actions>
    }
  </glxy-page-toolbar>

  <div class="detail">
    @if (!isOwned()) {
      <div class="detail__banner" role="note">
        <mat-icon class="detail__banner-icon">lock</mat-icon>
        <span>{{ 'KNOWLEDGE_SHARING.DETAIL.MANAGED_BY_BANNER' | translate: { partner: detail.kb.managedBy } }}</span>
      </div>
    }

    @if (detail.kb.description) {
      <div class="detail__description">
        <div class="detail__description-label">{{ 'KNOWLEDGE_SHARING.DETAIL.DESCRIPTION_LABEL' | translate }}</div>
        <p class="detail__description-text">{{ detail.kb.description }}</p>
      </div>
    }

    <div class="detail__grid">
      <!-- ── Sources — listed with the shared KnowledgeSourceTableComponent (read-only here) ── -->
      <section class="card card--wide">
        <div class="card__head">
          <div class="card__head-text">
            <h2 class="card__title">
              {{ 'KNOWLEDGE_SHARING.DETAIL.SOURCES' | translate }}
              <span class="card__count">{{ detail.sources.length }}</span>
            </h2>
            @if (isOwned()) {
              <p class="card__hint">{{ 'KNOWLEDGE_SHARING.DETAIL.SOURCES_HINT' | translate }}</p>
            } @else {
              <p class="card__hint">{{ 'KNOWLEDGE_SHARING.SOURCES.MANAGED_BY' | translate: { partner: detail.kb.managedBy } }}</p>
            }
          </div>
          @if (canEdit()) {
            <button mat-stroked-button class="card__head-action" (click)="addSource.emit(detail)">
              <mat-icon>add</mat-icon>
              {{ 'KNOWLEDGE_SHARING.DETAIL.ADD_SOURCE' | translate }}
            </button>
          }
        </div>
        @if (detail.sources.length === 0) {
          <p class="card__empty">{{ 'KNOWLEDGE_SHARING.DETAIL.NO_SOURCES' | translate }}</p>
        } @else {
          <ai-knowledge-knowledge-source-table
            class="detail__sources-table"
            [dataSource]="sourcesDataSource"
            [rows]="detail.sources"
            [editingEnabled]="false"
            [allowRemoveFromCollection]="canEdit()"
            [rawSourcesById]="noRawSources"
            (removeFromCollection)="removeSource.emit({ kb: detail.kb, source: $event })"
          />
        }
      </section>

      <!-- ── Shared with (only on sharing-capable surfaces) ── -->
      @if (showSharing()) {
        <section class="card card--wide">
          <div class="card__head">
            <div class="card__head-text">
              <h2 class="card__title">
                {{ 'KNOWLEDGE_SHARING.DETAIL.SHARED_WITH' | translate }}
                <span class="card__count">{{ detail.shares.length }}</span>
              </h2>
              <p class="card__hint">{{ 'KNOWLEDGE_SHARING.DETAIL.SHARED_WITH_HINT' | translate }}</p>
            </div>
          </div>
          @if (detail.shares.length === 0) {
            <p class="card__empty">{{ 'KNOWLEDGE_SHARING.DETAIL.NO_SHARES' | translate }}</p>
          } @else {
            <ul class="list">
              @for (grant of visible(detail.shares, showAllShares()); track trackGrantId($index, grant)) {
                <li class="list__row">
                  <div class="list__body">
                    <div class="list__name">{{ grant.target.displayName }}</div>
                    <div class="list__sub">
                      {{ 'KNOWLEDGE_SHARING.DETAIL.GRANTED_ON' | translate: { date: (grant.created | date: 'mediumDate') } }}
                    </div>
                  </div>
                  <button
                    mat-icon-button
                    class="list__revoke"
                    (click)="revokeShare.emit(grant)"
                    [matTooltip]="'KNOWLEDGE_SHARING.SHARE.REVOKE_SHARE' | translate"
                    [attr.aria-label]="'KNOWLEDGE_SHARING.SHARE.REVOKE_SHARE' | translate"
                  >
                    <mat-icon>close</mat-icon>
                  </button>
                </li>
              }
            </ul>
            @if (detail.shares.length > listLimit) {
              <button mat-button class="card__show-more" (click)="showAllShares.set(!showAllShares())">
                {{ showAllShares() ? ('KNOWLEDGE_SHARING.DETAIL.SHOW_LESS' | translate) : ('KNOWLEDGE_SHARING.DETAIL.SHOW_ALL' | translate: { count: detail.shares.length }) }}
              </button>
            }
          }
        </section>
      }
    </div>
  </div>
</glxy-page>
